//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import vRating from '~/components/v/rating.vue'
import SearchBarForm from '~/components/form/search-bar-form'
import settings from '~/mixins/settings'
import ScoreLine from '~/components/scoreLine.vue';

export default {
  name: 'MainVue',
  components: {
    ScoreLine,
    SearchBarForm,
    vRating
  },
  mixins: [settings],
  computed: {
    ...mapGetters({
      currentLanguage: 'lang/locale'
    })
  }
}
